/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_IdentityInputs */

const en_company_profile_identity = /** @type {(inputs: Company_Profile_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Identity`)
};

const de_company_profile_identity = /** @type {(inputs: Company_Profile_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensidentität`)
};

/**
* | output |
* | --- |
* | "Company Identity" |
*
* @param {Company_Profile_IdentityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_identity = /** @type {((inputs?: Company_Profile_IdentityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_IdentityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_identity(inputs)
	return en_company_profile_identity(inputs)
});